<script setup lang="ts">
import {onMounted, Ref, ref, watch} from 'vue'
import api from "@/app/services/api.ts";
import type {AxiosResponse} from "axios"
import {Country} from "@/domains/home/services/nir/forms/components/widgets/types";

const props = defineProps({
  active: Boolean,
  modelValue: {
    type: String,
  },
  data: {
    type: String,
  },
})

const emit = defineEmits<{
  (e: 'update:modelValue', countryId: string): void
}>()

const selectedCountryId = ref('')
const countries:Ref<Country[]> = ref([])

onMounted(() => {
  fetchCountries()
})

const fetchCountries = async () => {
  return api
      .get(`/configuration/address/country`)
      .then((response: AxiosResponse<Country[]>) => {
        countries.value = response.data
      })
}

watch(selectedCountryId, (newValue) => {
  emit('update:modelValue', newValue)
})

watch(() => props.data, () => {
  selectedCountryId.value = props.data ?? ""
})

</script>

<template>
  <div>
    <select
      v-model="selectedCountryId"
      :disabled="!active"
      class="w-full px-3 py-2 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-primary focus:border-primary">
      <option value="">Select a country</option>
      <option
        v-for="country in countries"
        :key="country.id"
        :value="country.id">
        {{ country.name }} ({{ country.code }})
      </option>
    </select>
  </div>
</template>

<style scoped></style>
